import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root'
})
export class ControlService {
  Controller: string = 'Control'
  constructor(private http: HttpClient) {}

  getControls(body: any) {
    return this.http.post(`${this.Controller}/GetControls`, body)
  }

  // .ng-select .ng-arrow-wrapper() {
  //   return this.http.get('Control/.ng-select .ng-arrow-wrapper');
  // }

  // getControlCategories() {
  //   return this.http.get('ControlCategory/GetControlCategories');
  // }

  createControl(body: any) {
    return this.http.post(`${this.Controller}/CreateControl`, body)
  }

  updateControl(body: any) {
    return this.http.put(`${this.Controller}/UpdateControl`, body)
  }

  getControlById(id: any) {
    return this.http.get(`${this.Controller}/GetControl/${id}`)
  }
  deleteControl(id: any) {
    return this.http.delete(`${this.Controller}/DeleteControl/${id}`)
  }

  createControlCategory(name: any) {
    return this.http.post(`ControlCategory/CreateControlCategory`, {
      name: name
    })
  }

  deleteControlCategory(id: any) {
    return this.http.request(
      'delete',
      `ControlCategory/DeleteControlCategory/${id}`,
      {}
    )
  }

  createControlDepartment(name: any) {
    return this.http.post(`Department/CreateDepartment`, {
      name: name
    })
  }

  deleteControlDepartment(id: any) {
    return this.http.request('delete', `Department/DeleteDepartment/${id}`, {})
  }

  getControlEffectivenessesLookups() {
    return this.http.get(`${this.Controller}/GetEffectivenesses`)
  }

  getReassesmentFrequencyByControlId(id: any) {
    return this.http.get(`${this.Controller}/ReassementFrequency/${id}`)
  }

  updateReassesmentFrequency(data: any) {
    return this.http.post(`${this.Controller}/ReassementFrequency`, data)
  }

  getMaintenanceFrequencyByControlId(id: any) {
    return this.http.get(`${this.Controller}/MaintenanceFrequency/${id}`)
  }

  updateMaintenanceFrequency(data: any) {
    return this.http.post(`${this.Controller}/MaintenanceFrequency`, data)
  }
  downloadTemplate() {
    return this.http.post(`${this.Controller}/Template`, '', {
      responseType: 'arraybuffer'
    })
  }

  import(formData: FormData) {
    return this.http.post(`${this.Controller}/Import`, formData, {
      responseType: 'blob',
      observe: 'response'
    })
  }

  exportAll(params: any) {
    return this.http.get(`${this.Controller}/Export`, {
      params,
      responseType: 'arraybuffer'
    })
  }
}
